import { motion } from "framer-motion";
import { useLang } from "../i18n";

const LOGO = "/images/3xayp9cj_LOGO_2__blanc_.png.webp";
const OUTLINE = "/images/corsica_outline.png";

const CITIES = [
  { name: "Bastia", x: 82, y: 25, side: "right" },
  { name: "Calvi", x: 15, y: 28, side: "right" },
  { name: "Corte", x: 55, y: 42, side: "right" },
  { name: "Ajaccio", x: 12, y: 65.5, side: "right" },
  { name: "Porto-Vecchio", x: 63.5, y: 86.5, side: "right" },
  { name: "Bonifacio", x: 60, y: 97, side: "right" },
];

const VILLA_POS = { x: 82.5, y: 83 };

export const CorsicaMap = () => {
  const { t } = useLang();
  return (
    <section className="bg-sand-bg py-24 md:py-32" data-testid="corsica-map-section">
      <div className="px-6 md:px-12 max-w-[1600px] mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-[11px] tracking-[0.35em] uppercase text-terracotta">{t.map.eyebrow}</span>
          <h2 className="font-serif font-light text-3xl md:text-5xl mt-4 tracking-tight max-w-md">{t.map.title}</h2>
          <p className="text-ink-soft font-light text-base md:text-lg leading-relaxed mt-6 max-w-md">{t.map.body}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
          className="flex justify-center"
        >
          <div className="relative w-full max-w-[280px]" data-testid="corsica-map-figure">
            <img src={OUTLINE} alt="Carte de la Corse" className="w-full h-auto" />
            {CITIES.map((c) => (
              <div key={c.name} className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center gap-1.5" style={{ left: `${c.x}%`, top: `${c.y}%` }}>
                {c.side === "right" && <span className="font-serif text-[13px] text-ink-soft whitespace-nowrap order-first pr-1">{c.name}</span>}
                <span className="w-2 h-2 rounded-full bg-ink block shrink-0" />
                {c.side === "left" && <span className="font-serif text-[13px] text-ink-soft whitespace-nowrap pl-1">{c.name}</span>}
              </div>
            ))}
            {/* marqueur villa */}
            <div className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: `${VILLA_POS.x}%`, top: `${VILLA_POS.y}%` }} data-testid="villa-map-marker">
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-terracotta animate-ping opacity-60" />
              <span className="relative block w-2.5 h-2.5 rounded-full bg-terracotta" />
              <div className="absolute left-3 bottom-2 flex items-center">
                <span className="block w-6 h-px bg-terracotta rotate-[-35deg] origin-left" />
                <span className="w-12 h-12 rounded-full bg-terracotta flex items-center justify-center -ml-1 -mt-10 shadow-lg">
                  <img src={LOGO} alt="Villa Tutto Passa" className="w-9 h-9 object-contain" />
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
